<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroup"
      :title="this.$lang.Groups.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtGroupsName"><small class="text-danger">*</small> {{$lang.Groups.LabelName}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          ref="txtGroupName"
                          name="txtGroupName"
                          :placeholder="$lang.Groups.PlaceholderEnterName"
                          v-model="form.nome.value"
                          :maxlength="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtDescription"> {{$lang.Groups.LabelDescription}}:</label>
          <b-form-textarea id="txtDescription"
                      name="txtDescription"
                      v-model="form.descricao.value"
                      :placeholder="$lang.Groups.PlaceholderEnterDescription"
                      :rows="form.descricao.rows"
                      :maxlength="form.descricao.maxlength"
                      :noResize="form.descricao.noResize"></b-form-textarea>
          <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
        </div>
      </div>
    </Forms>

    <Tables ref="tableGrid"
            :columns="[$lang.Groups.DataTable.Name,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.AccountAction,
                       $lang.Common.DataTable.Actions]"
            :showSearch="true"
            :showPrint="true"
            :showDownload="true"
            :showFullscreen="true"
            v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.nome" />
        <TableColumn :IsStatus="true" v-on:Edit="onSelect(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataAcao" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.nomeContaAcao" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>

  </div>
</template>

<script>
import Groups from './groups.js'

export default Groups
</script>



// WEBPACK FOOTER //
// src/views/private/access/groups/groups.vue